/* «Кадри» (/personnel), batch HR2: personnel file (П-2), staffing table, HR orders, vacations and sick leaves. Kept apart from uk.ts/en.ts to keep merges small. */
export const personnelUk = {
  'nav.personnel': 'Кадри',
  'perm.hr.personal.read': 'Кадри: персональні дані працівників (РНОКПП, документи, адреси, військовий облік) і оклади — кожен перегляд у журналі',
  'perm.hr.personal.manage': 'Кадри: особові справи, зв’язок з BAS, кадрові накази й відпустки',

  'pers.title': 'Кадри',
  'pers.subtitle':
    'Особові справи за формою П-2, штатний розклад, накази з кадрових питань, відпустки й лікарняні. Дані підтягуються з BAS «Зарплата і кадри»; персональні дані бачать лише кадровик, засновник і адміністратори.',
  'pers.employer': 'Роботодавець',
  'pers.allEmployers': 'Усі роботодавці',
  'pers.tabEmployees': 'Працівники',
  'pers.tabStaffing': 'Штатний розклад',
  'pers.tabOrders': 'Накази',
  'pers.tabLeaves': 'Відпустки й лікарняні',
  'pers.tabChecks': 'Перевірка й нагадування',
  'pers.tabReview': 'Зв’язок з BAS',
  'pers.noEmployers': 'Роботодавців ще немає',
  'pers.noEmployersHint': 'Додайте ФОПи і ТОВ у «Фінанси → ФОПи» та пов’яжіть їх з організаціями BAS.',

  'pers.staffingNoBas': 'Роботодавця не пов’язано з організацією BAS',
  'pers.staffingNoBasHint': 'Пов’яжіть ФОП / ТОВ з організацією BAS у картці ФОПа (блок «BAS»), і штатний розклад підтягнеться автоматично.',
  'pers.staffingEmpty': 'У BAS немає штатного розпису цього роботодавця',
  'pers.staffingEmptyHint': 'Штатний розпис ведеться в BAS («Штатний розклад»). Після синхронізації позиції з’являться тут.',
  'pers.rates': 'Ставок',
  'pers.occupied': 'Зайнято',
  'pers.vacant': 'Вакантно',
  'pers.vacancies': 'Вакансій',
  'pers.salaryFund': 'Фонд окладів',
  'pers.perMonth': 'грн на місяць',
  'pers.staffPosition': 'Посада',
  'pers.salary': 'Оклад',
  'pers.occupants': 'Хто займає',
  'pers.noDepartment': 'Без підрозділу',
  'pers.vacantN': 'вакантно {n}',
  'pers.overN': 'понад штат {n}',

  'pers.searchOrder': 'Номер, зміст або працівник',
  'pers.year': 'Рік',
  'pers.allYears': 'Усі роки',
  'pers.allKinds': 'Усі види',
  'pers.orderKind': 'Вид наказу',
  'pers.orderKind.hire': 'Прийняття',
  'pers.orderKind.transfer': 'Переведення',
  'pers.orderKind.dismissal': 'Звільнення',
  'pers.orderKind.vacation': 'Відпустка',
  'pers.orderKind.leave': 'Інша відпустка',
  'pers.orderKind.staffing': 'Штатний розпис',
  'pers.orderKind.discipline': 'Дисциплінарний',
  'pers.orderKind.other': 'Інший',
  'pers.orderStatus.draft': 'Чернетка',
  'pers.orderStatus.signed': 'Підписано',
  'pers.orderStatus.cancelled': 'Скасовано',
  'pers.newOrder': 'Новий наказ',
  'pers.editOrder': 'Наказ № {n}',
  'pers.orderHint': 'Нумерація окрема для кожного роботодавця і року («1-к», «2-к» …). Накази з BAS підтягуються автоматично.',
  'pers.orderNumber': 'Номер',
  'pers.orderNumberHint': 'Порожньо — наступний номер роботодавця в цьому році',
  'pers.auto': 'автоматично',
  'pers.orderTitle': 'Зміст',
  'pers.orderTitlePh': 'Про прийняття на роботу …',
  'pers.orderBody': 'Текст наказу',
  'pers.noOrders': 'Наказів ще немає',
  'pers.noOrdersHint': 'Накази про прийняття, переведення, звільнення й відпустки підтягуються з BAS. Новий наказ можна створити кнопкою «Новий наказ».',
  'pers.date': 'Дата',
  'pers.employee': 'Працівник',
  'pers.status': 'Стан',
  'pers.err.numberTaken': 'Цей номер уже є в наказах роботодавця за цей рік',
  'pers.err.dates': 'Кінець раніше за початок',

  'pers.view.list': 'Відпустки й лікарняні',
  'pers.view.balance': 'Залишки відпусток',
  'pers.view.schedule': 'Графік відпусток',
  'pers.leaveKind': 'Вид',
  'pers.leaveKind.annual': 'Щорічна основна',
  'pers.leaveKind.additional': 'Щорічна додаткова',
  'pers.leaveKind.unpaid': 'Без збереження зарплати',
  'pers.leaveKind.childcare': 'Догляд за дитиною',
  'pers.leaveKind.maternity': 'Вагітність і пологи',
  'pers.leaveKind.study': 'Навчальна',
  'pers.leaveKind.sick': 'Лікарняний',
  'pers.leaveKind.other': 'Інша',
  'pers.period': 'Період',
  'pers.days': 'Днів',
  'pers.daysShort': 'дн',
  'pers.basis': 'Підстава',
  'pers.addLeave': 'Записати відпустку',
  'pers.addLeaveHint': 'Для відпусток і лікарняних, яких немає в BAS (наприклад, у ФОПа без BAS).',
  'pers.addPlan': 'Додати до графіка',
  'pers.addPlanHint': 'Запланована відпустка (графік відпусток на рік). Залишок зменшиться, коли відпустку буде надано.',
  'pers.deleteLeave': 'Видалити запис про відпустку?',
  'pers.from': 'З',
  'pers.to': 'По',
  'pers.note': 'Примітка',
  'pers.calendarDays': '{n} календарних днів',
  'pers.noLeaves': 'Відпусток і лікарняних немає',
  'pers.noLeavesHint': 'Документи «Відпустка» і «Лікарняний» з BAS з’являються тут автоматично; інші можна записати вручну.',
  'pers.noBalance': 'Немає працюючих працівників',
  'pers.noBalanceHint': 'Залишки рахуються для карток працівників і працівників BAS, які не звільнені.',
  'pers.balanceNote':
    'Нараховано = днів на рік × відпрацьовані дні / 365 від дати прийняття. Днів на рік — з BAS (положені види відпусток) або норма «Щорічна основна відпустка» (24 дні, потребує підтвердження).',
  'pers.hiredOn': 'Прийнято',
  'pers.daysPerYear': 'Днів на рік',
  'pers.byNorm': 'норма',
  'pers.accrued': 'Нараховано',
  'pers.used': 'Використано',
  'pers.balance': 'Залишок',
  'pers.planned': 'За графіком',
  'pers.plannedFrom': '{n} дн з {d}',
  'pers.noSchedule': 'Графік відпусток порожній',
  'pers.noScheduleHint': 'Графік відпусток з BAS підтягується автоматично; можна додати заплановані відпустки вручну.',

  'pers.file': 'Особова справа',
  'pers.p2': 'Картка П-2 (PDF)',
  'pers.reveal': 'Показати персональні дані',
  'pers.hide': 'Сховати',
  'pers.revealedNote': 'Персональні дані показано — перегляд записано в журнал аудиту. Не копіюйте їх у месенджери й таблиці.',
  'pers.completeness': 'Заповнено {n}%',
  'pers.basLinked': 'Пов’язано з BAS',
  'pers.basNotLinked': 'Не пов’язано з BAS',
  'pers.missingN': 'Бракує обов’язкових відомостей: {n}',
  'pers.requiredMissing': 'Обов’язкове поле не заповнене',
  'pers.overridesBas': 'замість значення з BAS / Drive',
  'pers.editSection': 'Редагування: {s}',
  'pers.editHint': 'Значення, введене тут, має перевагу над BAS і Drive; порожнє поле повертає значення з BAS.',
  'pers.editHintMasked': 'Персональні поля приховано: порожнє поле їх не змінює. Щоб побачити поточні значення, натисніть «Показати персональні дані».',
  'pers.keepMasked': 'без змін (приховано)',
  'pers.history': 'Призначення й переведення (з BAS)',
  'pers.noHistory': 'У BAS немає кадрової історії цього працівника',
  'pers.event': 'Подія',
  'pers.order': 'Наказ',
  'pers.noOrdersEmployee': 'Наказів щодо працівника немає',
  'pers.noLeavesEmployee': 'Відпусток і лікарняних немає',
  'pers.plannedMark': 'за графіком',
  'pers.briefings': 'Інструктажі з охорони праці',
  'pers.medical': 'Медогляди й посвідчення',
  'pers.noBriefings': 'Інструктажів ще немає',
  'pers.noBriefingsHint': 'Журнал інструктажів і медогляди ведуться в «Персонал → Журнал інструктажів» і в картці працівника.',
  'pers.noCertificates': 'Медоглядів і посвідчень немає',
  'pers.nextDue': 'наступний до {d}',
  'pers.validUntil': 'до {d}',
  'pers.noEmployees': 'Карток працівників ще немає',
  'pers.noEmployeesHint': 'Картки створюються в «Персонал» або з працівників BAS на вкладці «Зв’язок з BAS».',
  'pers.onlyIncomplete': 'Лише незаповнені',
  'pers.fileState': 'Особова справа',
  'pers.missingShort': 'бракує {n}',
  'pers.expiringShort': 'спливає {n}',
  'pers.linked': 'пов’язано',
  'pers.notLinked': 'немає',
  'pers.expiringTitle': 'Спливає або прострочено',
  'pers.nothingExpiring': 'Нічого не спливає найближчі 60 днів',
  'pers.missingTitle': 'Бракує за законом',
  'pers.allComplete': 'Усі особові справи заповнені',
  'pers.reviewsTitle': 'Можливі збіги',
  'pers.reviewsHint': 'Картка і людина в BAS збігаються лише за ПІБ. Підтвердіть, що це одна людина, або відхиліть — тоді збіг більше не пропонуватиметься.',
  'pers.noReviews': 'Немає збігів, що чекають рішення',
  'pers.samePerson': 'Та сама людина',
  'pers.differentPeople': 'Різні люди',
  'pers.withoutCardTitle': 'Працюють у BAS, але картки немає',
  'pers.allHaveCards': 'Усі працівники BAS мають картки',
  'pers.createCard': 'Створити картку',
  'pers.withoutBasTitle': 'Картки без BAS',
  'pers.withoutBasHint': 'Введіть РНОКПП або дату народження в особовій справі — картка зв’яжеться з BAS автоматично, або оберіть працівника BAS вручну.',
  'pers.allLinked': 'Усі картки пов’язані з BAS',
  'pers.linkToBas': 'Пов’язати з BAS…',
  'pers.linkTo': 'Пов’язати {n} з працівником BAS',
  'pers.syncNow': 'Пов’язати зараз',
  'pers.syncDone': 'Оновлено записів: {n}; нових збігів: {r}',
  'pers.reason.name': 'ПІБ',
  'pers.reason.dob': 'дата народження',
  'pers.reason.phone': 'телефон',
  'pers.reason.email': 'e-mail',
  'pers.fileTab.personal': 'Особисті дані',
  'pers.fileTab.work': 'Робота й переміщення',
  'pers.fileTab.orders': 'Накази',
  'pers.fileTab.leaves': 'Відпустки й лікарняні',
  'pers.fileTab.military': 'Військовий облік',
  'pers.fileTab.education': 'Освіта',
  'pers.fileTab.documents': 'Документи',
  'pers.fileTab.safety': 'Інструктажі й медогляди',
  'pers.section.personal': 'Загальні відомості',
  'pers.section.documents': 'Документ, що посвідчує особу',
  'pers.section.contacts': 'Місце проживання і контакти',
  'pers.section.work': 'Робота',
  'pers.section.education': 'Освіта',
  'pers.section.family': 'Родинний стан',
  'pers.section.social': 'Пільги й інвалідність',
  'pers.section.military': 'Військовий облік',
  'pers.section.consent': 'Згода на обробку персональних даних',
  'pers.source.bas': 'BAS',
  'pers.source.drive': 'Drive',
  'pers.source.manual': 'вручну',
  'pers.source.card': 'картка',
  'pers.source.enote': 'Enote',
  'pers.source.bridge': 'Bridge',
  'pers.choice.female': 'жіноча',
  'pers.choice.male': 'чоловіча',
  'pers.choice.main': 'основне місце роботи',
  'pers.choice.part_time_external': 'зовнішнє сумісництво',
  'pers.choice.part_time_internal': 'внутрішнє сумісництво',
  'pers.choice.paper': 'паперова',
  'pers.choice.electronic': 'електронна',
  'pers.choice.none': 'немає',
  'pers.choice.basic_secondary': 'базова загальна середня',
  'pers.choice.full_secondary': 'повна загальна середня',
  'pers.choice.vocational': 'професійно-технічна',
  'pers.choice.junior_bachelor': 'фаховий молодший бакалавр',
  'pers.choice.bachelor': 'бакалавр',
  'pers.choice.master': 'магістр',
  'pers.choice.phd': 'доктор філософії',
  'pers.choice.single': 'неодружений(а)',
  'pers.choice.married': 'одружений(а)',
  'pers.choice.divorced': 'розлучений(а)',
  'pers.choice.widowed': 'вдівець / вдова',
  'pers.choice.not_liable': 'не перебуває на обліку',
  'pers.choice.conscript': 'призовник',
  'pers.choice.liable': 'військовозобов’язаний',
  'pers.choice.reservist': 'резервіст',
  'pers.field.surname': 'Прізвище',
  'pers.field.first_name': 'Ім’я',
  'pers.field.patronymic': 'По батькові',
  'pers.field.birth_date': 'Дата народження',
  'pers.field.birth_place': 'Місце народження',
  'pers.field.sex': 'Стать',
  'pers.field.citizenship': 'Громадянство',
  'pers.field.rnokpp': 'РНОКПП (ІПН)',
  'pers.field.unzr': 'УНЗР',
  'pers.field.id_doc_kind': 'Вид документа',
  'pers.field.id_doc_number': 'Серія і номер',
  'pers.field.id_doc_issued_by': 'Ким виданий',
  'pers.field.id_doc_issued_on': 'Дата видачі',
  'pers.field.id_doc_valid_until': 'Дійсний до',
  'pers.field.reg_address': 'Адреса реєстрації',
  'pers.field.live_address': 'Фактична адреса',
  'pers.field.phone': 'Телефон',
  'pers.field.email': 'E-mail',
  'pers.field.employer': 'Роботодавець',
  'pers.field.position': 'Посада',
  'pers.field.department': 'Підрозділ',
  'pers.field.hire_date': 'Дата прийняття',
  'pers.field.hire_order': 'Наказ про прийняття',
  'pers.field.contract_kind': 'Вид договору',
  'pers.field.employment_kind': 'Характер роботи',
  'pers.field.rate': 'Ставка',
  'pers.field.work_book': 'Трудова книжка',
  'pers.field.work_book_pfu': 'Відомості до ПФУ передано',
  'pers.field.dps_notice': 'Повідомлення ДПС про прийняття',
  'pers.field.seniority_total': 'Загальний стаж',
  'pers.field.dismissal_date': 'Дата звільнення',
  'pers.field.dismissal_ground': 'Підстава звільнення',
  'pers.field.education_level': 'Освіта',
  'pers.field.education_institution': 'Навчальний заклад',
  'pers.field.education_specialty': 'Спеціальність',
  'pers.field.education_diploma': 'Диплом',
  'pers.field.education_year': 'Рік закінчення',
  'pers.field.marital_status': 'Родинний стан',
  'pers.field.family_members': 'Склад сім’ї',
  'pers.field.disability': 'Інвалідність',
  'pers.field.benefits': 'Пільги',
  'pers.field.military_status': 'Військовий облік',
  'pers.field.military_category': 'Категорія обліку',
  'pers.field.military_composition': 'Склад',
  'pers.field.military_rank': 'Військове звання',
  'pers.field.military_vos': 'ВОС',
  'pers.field.military_fitness': 'Придатність',
  'pers.field.military_tck': 'ТЦК та СП',
  'pers.field.military_doc': 'Військово-обліковий документ',
  'pers.field.military_reserved': 'Бронювання',
  'pers.field.pd_consent': 'Згода на обробку ПД (дата)',
  'pers.field.medical_exam': 'Чинний медогляд',
  'pers.field.ohs_briefing': 'Вступний інструктаж з охорони праці',
}

export const personnelEn: { [K in keyof typeof personnelUk]?: string } = {
  'nav.personnel': 'HR office',
  'perm.hr.personal.read': 'HR office: employees’ personal data (tax number, documents, addresses, military registration) and salaries — every view is logged',
  'perm.hr.personal.manage': 'HR office: personnel files, BAS links, HR orders and leaves',

  'pers.title': 'HR office',
  'pers.subtitle':
    'Personnel files (form P-2), staffing table, HR orders, vacations and sick leaves. Data comes from BAS «Payroll and HR»; personal data is visible only to the HR officer, the founder and admins.',
  'pers.employer': 'Employer',
  'pers.allEmployers': 'All employers',
  'pers.tabEmployees': 'Employees',
  'pers.tabStaffing': 'Staffing table',
  'pers.tabOrders': 'Orders',
  'pers.tabLeaves': 'Vacations and sick leaves',
  'pers.tabChecks': 'Checks and reminders',
  'pers.tabReview': 'BAS links',
  'pers.noEmployers': 'No employers yet',
  'pers.noEmployersHint': 'Add ФОПи and the ТОВ in Finance → ФОПи and link them to BAS organizations.',

  'pers.staffingNoBas': 'The employer is not linked to a BAS organization',
  'pers.staffingNoBasHint': 'Link the ФОП / ТОВ to its BAS organization on the ФОП card (BAS block) and the staffing table appears automatically.',
  'pers.staffingEmpty': 'BAS has no staffing table for this employer',
  'pers.staffingEmptyHint': 'The staffing table is kept in BAS. After the sync its positions appear here.',
  'pers.rates': 'Units',
  'pers.occupied': 'Occupied',
  'pers.vacant': 'Vacant',
  'pers.vacancies': 'Vacancies',
  'pers.salaryFund': 'Salary fund',
  'pers.perMonth': 'UAH per month',
  'pers.staffPosition': 'Position',
  'pers.salary': 'Salary',
  'pers.occupants': 'Occupied by',
  'pers.noDepartment': 'No department',
  'pers.vacantN': '{n} vacant',
  'pers.overN': '{n} over the table',

  'pers.searchOrder': 'Number, subject or employee',
  'pers.year': 'Year',
  'pers.allYears': 'All years',
  'pers.allKinds': 'All kinds',
  'pers.orderKind': 'Order kind',
  'pers.orderKind.hire': 'Hire',
  'pers.orderKind.transfer': 'Transfer',
  'pers.orderKind.dismissal': 'Dismissal',
  'pers.orderKind.vacation': 'Vacation',
  'pers.orderKind.leave': 'Other leave',
  'pers.orderKind.staffing': 'Staffing table',
  'pers.orderKind.discipline': 'Disciplinary',
  'pers.orderKind.other': 'Other',
  'pers.orderStatus.draft': 'Draft',
  'pers.orderStatus.signed': 'Signed',
  'pers.orderStatus.cancelled': 'Cancelled',
  'pers.newOrder': 'New order',
  'pers.editOrder': 'Order № {n}',
  'pers.orderHint': 'Numbering is separate per employer and year («1-к», «2-к» …). Orders from BAS come in automatically.',
  'pers.orderNumber': 'Number',
  'pers.orderNumberHint': 'Empty = the employer’s next number this year',
  'pers.auto': 'automatic',
  'pers.orderTitle': 'Subject',
  'pers.orderTitlePh': 'On hiring …',
  'pers.orderBody': 'Text of the order',
  'pers.noOrders': 'No orders yet',
  'pers.noOrdersHint': 'Hire, transfer, dismissal and vacation orders come from BAS. Create a new one with «New order».',
  'pers.date': 'Date',
  'pers.employee': 'Employee',
  'pers.status': 'State',
  'pers.err.numberTaken': 'The employer already has this number this year',
  'pers.err.dates': 'The end is before the start',

  'pers.view.list': 'Vacations and sick leaves',
  'pers.view.balance': 'Vacation balance',
  'pers.view.schedule': 'Vacation schedule',
  'pers.leaveKind': 'Kind',
  'pers.leaveKind.annual': 'Annual basic',
  'pers.leaveKind.additional': 'Annual additional',
  'pers.leaveKind.unpaid': 'Unpaid',
  'pers.leaveKind.childcare': 'Childcare',
  'pers.leaveKind.maternity': 'Maternity',
  'pers.leaveKind.study': 'Study',
  'pers.leaveKind.sick': 'Sick leave',
  'pers.leaveKind.other': 'Other',
  'pers.period': 'Period',
  'pers.days': 'Days',
  'pers.daysShort': 'd',
  'pers.basis': 'Basis',
  'pers.addLeave': 'Record a leave',
  'pers.addLeaveHint': 'For vacations and sick leaves that are not in BAS (e.g. a ФОП without BAS).',
  'pers.addPlan': 'Add to the schedule',
  'pers.addPlanHint': 'A planned vacation (the yearly vacation schedule). The balance drops when the vacation is granted.',
  'pers.deleteLeave': 'Delete this leave?',
  'pers.from': 'From',
  'pers.to': 'To',
  'pers.note': 'Note',
  'pers.calendarDays': '{n} calendar days',
  'pers.noLeaves': 'No vacations or sick leaves',
  'pers.noLeavesHint': 'Vacation and sick-leave documents from BAS appear here automatically; others can be recorded manually.',
  'pers.noBalance': 'No working employees',
  'pers.noBalanceHint': 'Balances are computed for employee cards and BAS employees who have not left.',
  'pers.balanceNote':
    'Accrued = days per year × days worked / 365 since hiring. Days per year come from BAS (vacation entitlements) or the norm «Annual basic vacation» (24 days, to confirm).',
  'pers.hiredOn': 'Hired',
  'pers.daysPerYear': 'Days per year',
  'pers.byNorm': 'norm',
  'pers.accrued': 'Accrued',
  'pers.used': 'Used',
  'pers.balance': 'Balance',
  'pers.planned': 'Scheduled',
  'pers.plannedFrom': '{n} d from {d}',
  'pers.noSchedule': 'The vacation schedule is empty',
  'pers.noScheduleHint': 'The BAS vacation schedule comes in automatically; planned vacations can be added manually.',

  'pers.file': 'Personnel file',
  'pers.p2': 'P-2 card (PDF)',
  'pers.reveal': 'Show personal data',
  'pers.hide': 'Hide',
  'pers.revealedNote': 'Personal data is shown — this view is written to the audit log. Do not copy it to messengers or sheets.',
  'pers.completeness': '{n}% complete',
  'pers.basLinked': 'Linked to BAS',
  'pers.basNotLinked': 'Not linked to BAS',
  'pers.missingN': 'Required items missing: {n}',
  'pers.requiredMissing': 'Required field is empty',
  'pers.overridesBas': 'instead of the BAS / Drive value',
  'pers.editSection': 'Edit: {s}',
  'pers.editHint': 'A value entered here wins over BAS and Drive; an empty field brings the BAS value back.',
  'pers.editHintMasked': 'Personal fields are hidden: an empty field leaves them unchanged. Press «Show personal data» to see the current values.',
  'pers.keepMasked': 'unchanged (hidden)',
  'pers.history': 'Appointments and transfers (from BAS)',
  'pers.noHistory': 'BAS has no HR history for this employee',
  'pers.event': 'Event',
  'pers.order': 'Order',
  'pers.noOrdersEmployee': 'No orders for this employee',
  'pers.noLeavesEmployee': 'No vacations or sick leaves',
  'pers.plannedMark': 'scheduled',
  'pers.briefings': 'Occupational safety briefings',
  'pers.medical': 'Medical exams and certificates',
  'pers.noBriefings': 'No briefings yet',
  'pers.noBriefingsHint': 'The briefing journal and medical exams are kept in Staff → Briefing journal and on the employee card.',
  'pers.noCertificates': 'No medical exams or certificates',
  'pers.nextDue': 'next by {d}',
  'pers.validUntil': 'until {d}',
  'pers.noEmployees': 'No employee cards yet',
  'pers.noEmployeesHint': 'Cards are created in Staff or from BAS employees on the «BAS links» tab.',
  'pers.onlyIncomplete': 'Incomplete only',
  'pers.fileState': 'Personnel file',
  'pers.missingShort': '{n} missing',
  'pers.expiringShort': '{n} expiring',
  'pers.linked': 'linked',
  'pers.notLinked': 'no',
  'pers.expiringTitle': 'Expiring or overdue',
  'pers.nothingExpiring': 'Nothing expires in the next 60 days',
  'pers.missingTitle': 'Missing by law',
  'pers.allComplete': 'All personnel files are complete',
  'pers.reviewsTitle': 'Possible matches',
  'pers.reviewsHint': 'A card and a BAS person agree only by name. Confirm they are one person or reject — then the match is never proposed again.',
  'pers.noReviews': 'No matches waiting for a decision',
  'pers.samePerson': 'Same person',
  'pers.differentPeople': 'Different people',
  'pers.withoutCardTitle': 'Working in BAS without a card',
  'pers.allHaveCards': 'Every BAS employee has a card',
  'pers.createCard': 'Create a card',
  'pers.withoutBasTitle': 'Cards without BAS',
  'pers.withoutBasHint': 'Enter the tax number or the birth date in the personnel file and the card links to BAS automatically, or pick the BAS employee by hand.',
  'pers.allLinked': 'All cards are linked to BAS',
  'pers.linkToBas': 'Link to BAS…',
  'pers.linkTo': 'Link {n} to a BAS employee',
  'pers.syncNow': 'Link now',
  'pers.syncDone': 'Records updated: {n}; new matches: {r}',
  'pers.reason.name': 'name',
  'pers.reason.dob': 'birth date',
  'pers.reason.phone': 'phone',
  'pers.reason.email': 'e-mail',
  'pers.fileTab.personal': 'Personal data',
  'pers.fileTab.work': 'Work and transfers',
  'pers.fileTab.orders': 'Orders',
  'pers.fileTab.leaves': 'Vacations and sick leaves',
  'pers.fileTab.military': 'Military registration',
  'pers.fileTab.education': 'Education',
  'pers.fileTab.documents': 'Documents',
  'pers.fileTab.safety': 'Briefings and medical exams',
  'pers.section.personal': 'General',
  'pers.section.documents': 'Identity document',
  'pers.section.contacts': 'Address and contacts',
  'pers.section.work': 'Work',
  'pers.section.education': 'Education',
  'pers.section.family': 'Family',
  'pers.section.social': 'Benefits and disability',
  'pers.section.military': 'Military registration',
  'pers.section.consent': 'Consent to personal data processing',
  'pers.source.bas': 'BAS',
  'pers.source.drive': 'Drive',
  'pers.source.manual': 'manual',
  'pers.source.card': 'card',
  'pers.source.enote': 'Enote',
  'pers.source.bridge': 'Bridge',
  'pers.choice.female': 'female',
  'pers.choice.male': 'male',
  'pers.choice.main': 'main job',
  'pers.choice.part_time_external': 'external part-time',
  'pers.choice.part_time_internal': 'internal part-time',
  'pers.choice.paper': 'paper',
  'pers.choice.electronic': 'electronic',
  'pers.choice.none': 'none',
  'pers.choice.basic_secondary': 'basic secondary',
  'pers.choice.full_secondary': 'full secondary',
  'pers.choice.vocational': 'vocational',
  'pers.choice.junior_bachelor': 'junior bachelor',
  'pers.choice.bachelor': 'bachelor',
  'pers.choice.master': 'master',
  'pers.choice.phd': 'PhD',
  'pers.choice.single': 'single',
  'pers.choice.married': 'married',
  'pers.choice.divorced': 'divorced',
  'pers.choice.widowed': 'widowed',
  'pers.choice.not_liable': 'not registered',
  'pers.choice.conscript': 'conscript',
  'pers.choice.liable': 'liable for service',
  'pers.choice.reservist': 'reservist',
  'pers.field.surname': 'Surname',
  'pers.field.first_name': 'First name',
  'pers.field.patronymic': 'Patronymic',
  'pers.field.birth_date': 'Birth date',
  'pers.field.birth_place': 'Birth place',
  'pers.field.sex': 'Sex',
  'pers.field.citizenship': 'Citizenship',
  'pers.field.rnokpp': 'Tax number (РНОКПП)',
  'pers.field.unzr': 'УНЗР',
  'pers.field.id_doc_kind': 'Document kind',
  'pers.field.id_doc_number': 'Series and number',
  'pers.field.id_doc_issued_by': 'Issued by',
  'pers.field.id_doc_issued_on': 'Issued on',
  'pers.field.id_doc_valid_until': 'Valid until',
  'pers.field.reg_address': 'Registered address',
  'pers.field.live_address': 'Actual address',
  'pers.field.phone': 'Phone',
  'pers.field.email': 'E-mail',
  'pers.field.employer': 'Employer',
  'pers.field.position': 'Position',
  'pers.field.department': 'Department',
  'pers.field.hire_date': 'Hired on',
  'pers.field.hire_order': 'Hiring order',
  'pers.field.contract_kind': 'Contract kind',
  'pers.field.employment_kind': 'Employment kind',
  'pers.field.rate': 'Rate',
  'pers.field.work_book': 'Work book',
  'pers.field.work_book_pfu': 'Records sent to the Pension Fund',
  'pers.field.dps_notice': 'Tax office hiring notice',
  'pers.field.seniority_total': 'Total seniority',
  'pers.field.dismissal_date': 'Dismissed on',
  'pers.field.dismissal_ground': 'Dismissal ground',
  'pers.field.education_level': 'Education',
  'pers.field.education_institution': 'Institution',
  'pers.field.education_specialty': 'Speciality',
  'pers.field.education_diploma': 'Diploma',
  'pers.field.education_year': 'Graduation year',
  'pers.field.marital_status': 'Marital status',
  'pers.field.family_members': 'Family members',
  'pers.field.disability': 'Disability',
  'pers.field.benefits': 'Benefits',
  'pers.field.military_status': 'Military registration',
  'pers.field.military_category': 'Registration category',
  'pers.field.military_composition': 'Composition',
  'pers.field.military_rank': 'Rank',
  'pers.field.military_vos': 'Military speciality (ВОС)',
  'pers.field.military_fitness': 'Fitness',
  'pers.field.military_tck': 'Recruitment centre (ТЦК)',
  'pers.field.military_doc': 'Military registration document',
  'pers.field.military_reserved': 'Deferment (бронювання)',
  'pers.field.pd_consent': 'Personal data consent (date)',
  'pers.field.medical_exam': 'Valid medical exam',
  'pers.field.ohs_briefing': 'Introductory OHS briefing',
}
